import { EnvironmentService } from '@experian-shared/services';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import {
  MyTermAcceptRequest,
  MyTermContentResponse,
  MyTermResponse,
  MyTermsResponse,
} from '../models/terms.model';

@Injectable({
  providedIn: 'root',
})
export class TermsService {
  public termsData$ = new Subject<MyTermResponse[]>();
  public termsDataError$ = new Subject<boolean>();
  public termIsMandatoryAcceptance$ = new Subject<boolean>();

  constructor(
    private http: HttpClient,
    public environmentService: EnvironmentService
  ) {}

  findMyTerms(
    channelCode?: string,
    accessToken?: string
  ): Observable<MyTermsResponse> {
    const queryParams = channelCode
      ? new HttpParams().set('channelCode', channelCode || '')
      : null;
    const headers = this.simpleHeaders.append(
      // eslint-disable-next-line
      'Authorization', //NOSONAR
      `Bearer ${accessToken}`
    );
    const API_URL = `${this.environmentService.env.source}`;
    return this.http.get<MyTermsResponse>(
      `${API_URL}/product-menu/security/v1/my-terms`,
      { headers, params: queryParams }
    );
  }

  retrieveMyTerm(
    termId: string,
    accessToken?: string
  ): Observable<MyTermContentResponse> {
    const headers = this.simpleHeaders.append(
      // eslint-disable-next-line
      'Authorization', //NOSONAR
      `Bearer ${accessToken}`
    );
    const API_URL = `${this.environmentService.env.source}`;
    return this.http.get<MyTermContentResponse>(
      `${API_URL}/digital/terms/v1/my-terms/${encodeURIComponent(
        termId
      )}/content`,
      { headers }
    );
  }

  acceptMyTerms(
    myTermAcceptRequest: MyTermAcceptRequest,
    accessToken?: string
  ): Observable<void> {
    const headers = this.simpleHeaders.append(
      // eslint-disable-next-line
      'Authorization', //NOSONAR
      `Bearer ${accessToken}`
    );
    const API_URL = `${this.environmentService.env.source}`;
    return this.http.post<void>(
      `${API_URL}/digital/terms/v1/my-terms/accept-terms`,
      myTermAcceptRequest,
      { headers }
    );
  }

  private get simpleHeaders(): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json' });
  }
}
